import { FamilyLoaderWrapper } from './style'
import Loader from 'components/shared/Loader'
import whiteLoader from 'assets/icons/white-loader.svg'
import newLoader from 'assets/icons/new-loader.svg'

export const FamilyLoader = ({ hasDarkMode }: { hasDarkMode?: boolean }) => (
    <FamilyLoaderWrapper
        justify="center"
        align="center"
        isFullWidth
        bgColor={hasDarkMode ? 'grayscale_900' : 'grayscale_200'}
        borderColor={hasDarkMode ? 'darkmode_500' : 'grayscale_400'}
        borderWidth={2}
    >
        <Loader src={hasDarkMode ? whiteLoader : newLoader} />
    </FamilyLoaderWrapper>
)
